// Centralized company data – used in legal pages, footer, contact, invoices etc.
// Edit values here to update everywhere on the site.

export const COMPANY = {
  legal_name: "ANAIZA SHOP S.R.L.",
  brand: "ANAIZA SHOP",
  reg_com: "J37/248/2023",
  cif: "RO47937300",
  vat_payer: true,
  vat_rate: 19,
  address: {
    street: "Str. Alexandru Moruzzi, Nr. 27A, Hala 3",
    city: "Galați",
    county: "Galați",
    country: "România",
    postal: "",
  },
  contact: {
    email: "Anaiza.shop@yahoo.com",
    phone: "0756 889 809",
    phone_tel: "+40756889809",
    whatsapp: "40756889809",
    schedule: "Luni – Vineri · 09:00–18:00 · Sâmbătă · 10:00–14:00",
  },
  policies: {
    return_days: 14,
    warranty_months: 24,
    shipping_cost: 19.99,
    free_shipping_threshold: null,
  },
  payments: ["Card bancar (Stripe – Visa, Mastercard)", "Ramburs la livrare"],
};

export const fullAddress = () => {
  const a = COMPANY.address;
  return `${a.street}, Mun. ${a.city}, Județ ${a.county}, ${a.country}`;
};
